<template>
  <div :class="['room', { room__recruiter: is_recruiter, room__candidate: !is_recruiter }]">
    <div v-if="!is_recruiter" class="room__logo">
      <img :src="data.company.logo" alt="" />
    </div>
    <div id="videos" class="room__videos">
      <div
        :class="[
          'local-video',
          {
            'local-video__preview': participants.length,
            'local-video-muted': videoMuted
          }
        ]"
        ref="local_video"
      >
        <div class="participant-name">
          {{ current_participant ? current_participant.name : '' }}
        </div>
      </div>
      <div ref="participants" class="participants"></div>

      <div id="controls-div" class="room__controls">
        <controls type="micro" @mute_audio="mute_audio" />
        <controls type="hangup" @hangup="set_hangup(true)" />
        <controls type="video" @mute_video="mute_video" />
        <controls v-if="is_recruiter" type="record" :is_active="record_video" @record="record" />
      </div>

      <div v-if="hangup_room" class="room__hangup">
        <div class="room__hangup-title">
          {{ $tr('onlineInterview.room.hangup') }}
        </div>
        <div class="room__hangup-btns">
          <vbutton
            class="room__hangup-btn room__hangup-btn_left"
            label="onlineInterview.room.leave"
            @click="hangup"
          />
          <vbutton
            v-if="data.user_has_access"
            class="room__hangup-btn room__hangup-btn_right"
            label="onlineInterview.room.endMeeting"
            :color="'grey'"
            @click="hangup_all"
          />
        </div>
        <div class="room__hangup-close" @click="set_hangup(false)"></div>
      </div>
    </div>

    <timer class="timer-block" :inited="duration" @end_time="end_time" />
  </div>
</template>

<script>
  import Video, { LocalDataTrack } from 'twilio-video';
  import BrowserStore from 'store';
  import Moment from 'moment';
  import controls from './components/controls.vue';
  // import participants from './components/participants.vue';
  import timer from './components/timer.vue';

  export default {
    name: 'room',

    components: {
      controls,
      // participants,
      timer
    },

    props: {
      data: {
        type: Object,
        default: () => {}
      },

      is_recruiter: {
        type: Boolean,
        default: false
      },

      participants_data: {
        type: Array,
        default: () => []
      }
    },

    data() {
      return {
        config: {
          tracks: {
            audio: true,
            data: true,
            video: {
              width: 1920,
              height: 1080
            }
          }
        },

        duration_room: 3000,
        videoMuted: false,
        audioMuted: false,
        record_video: false,
        hangup_room: false,
        room: null,
        dataTrackPublished: {},
        current_speaker: null,
        participants: [],
        local_tracks: null,
        localDataTrack: new Video.LocalDataTrack(),
        participants_names: null,
        isClosed: false
      };
    },

    computed: {
      current_participant() {
        return this.data ? this.data.current_participant : null;
      },

      date_created() {
        return this.data ? Moment(this.data.room.date_created).format('HH:mm:ss') : null;
      },

      current_time() {
        return Moment().format('HH:mm:ss');
      },

      duration_start() {
        return Moment.duration(this.date_created, 'seconds') / 1000;
      },

      duration_end() {
        return Moment.duration(this.current_time, 'seconds') / 1000;
      },

      duration() {
        return this.duration_room - (this.duration_end - this.duration_start);
      },

      partipiants_names_list: {
        get() {
          if (!this.participants_names) {
            return this.participants_data || [];
          }
          return this.participants_names;
        },

        set(val) {
          this.participants_names = val;
        }
      }
    },

    watch: {
      partipiants_names_list: {
        immediate: true,
        handler(val) {
          if (val && val.length) {
            val.forEach(item => {
              let el = document.getElementById(`name_${item.id_participant}`);
              if (el) {
                el.innerText = item.name;
              }
            });
          }
        }
      }
    },

    beforeDestroy() {
      this.hangup();
      localStorage.removeItem(`room_join_${this.data.token}`);
    },

    created() {
      this.connect();
      BrowserStore.set(`room_join_${this.data.token}`, true);

      if (this.data.record) {
        this.record_video = true;
      }
      const token = this.data.token;

      window.onbeforeunload = function () {
        localStorage.removeItem(`room_join_${token}`);
        return '';
      };
    },

    mounted() {
      // Пришлось сделать костыль, twilio динамически создает элементы с участниками комнаты, добавил слушатель, чтобы отслеживать клики
      this.$refs.participants.addEventListener('click', e => {
        this.set_participant(e);
      });
    },

    methods: {
      connect() {
        Video.createLocalTracks(this.config.tracks)
          .then(local_tracks => {
            this.local_tracks = [...local_tracks, this.localDataTrack];

            this.local_tracks.forEach(track => {
              if (track.kind === 'video') {
                this.$refs.local_video.appendChild(track.attach());
              }
            });
            let options = {
              name: this.data.room.hash,
              tracks: this.local_tracks,
              dominantSpeaker: true
            };
            return Video.connect(this.current_participant.token, options);
          })
          .then(room => {
            this.room = room;
            if (room && room.participants && room.participants.size >= 5) {
              this.isClosed = true;
            }
            this.events_room();
          })
          .catch(err => {
            if (err && err.message === 'Room contains too many Participants') {
              this.isClosed = true;
              this.tooManyExitRoom();
              this.$emit('end_room_too_many');
            }
          });
      },

      events_room() {
        this.room.participants.forEach(participant => this.participantConnected(participant)); // Заходит новый участник комнаты
        this.room.on('participantConnected', participant => this.participantConnected(participant)); // Заходит новый участник комнаты
        this.room.on('dominantSpeakerChanged', participant => this.set_speaker(participant)); // Текущий спикер
        this.room.on('participantDisconnected', participant =>
          this.participantDisconnected(participant)
        ); // Выходит участник комнаты
        this.room.once('disconnected', room => {
          // this.room.participants.forEach(participant => this.participantDisconnected(participant)); // Выходит участник комнаты
          this.room = room;
          this.room.localParticipant.tracks.forEach(publication => {
            if (!publication || !publication.track || !publication.track.detach) {
              return;
            }
            const attachedElements = publication.track.detach();
            attachedElements.forEach(element => element.remove());
          }); // Выходит участник комнаты

          if (this.local_tracks && this.local_tracks.length) {
            this.local_tracks.forEach(item => {
              if (item.stop) {
                item.stop();
              }
            });
          }

          if (this.isClosed) {
            this.$emit('end_room_too_many');
          } else {
            this.$emit('end_room');
          }
        });

        this.dataTrackPublished.promise = new Promise((resolve, reject) => {
          this.dataTrackPublished.resolve = resolve;
          this.dataTrackPublished.reject = reject;
        });
        this.room.localParticipant.on('trackPublished', publication => {
          // console.warn('trackPublished', publication);
          if (publication.track === this.localDataTrack) {
            this.dataTrackPublished.resolve();
          }
        });

        this.room.localParticipant.on('trackPublicationFailed', (error, track) => {
          // console.warn('trackPublicationFailed', error);
          if (track === this.localDataTrack) {
            this.dataTrackPublished.reject(error);
          }
        });

        this.room.on('trackSubscribed', track => {
          track.on('message', message => {
            this.handle_message(message);
          });
        });

        this.sendMessage(
          JSON.stringify({
            type: 'join',
            list: this.partipiants_names_list
          })
        );

        if (this.isClosed) {
          this.tooManyExitRoom();
        }
      },

      handle_message(message) {
        if (message === 'hangup_all') {
          this.hangup();
        }
        if (message === 'record_video_start') {
          this.record_video = true;
        }
        if (message === 'record_video_stop') {
          this.record_video = false;
        }

        let msg_object = null;
        try {
          msg_object = JSON.parse(message);
        } catch (e) {
          console.warn('e: ', e);
        }

        if (msg_object) {
          if (msg_object.type === 'join') {
            this.partipiants_names_list = msg_object.list;
          } else if (msg_object.type === 'setSpeakerFromMessage') {
            this.setSpeakerFromMessage(msg_object.participant);
          }
        }
      },

      participantConnected(participant) {
        // console.warn('participantConnected', participant);
        if (this.participants.length >= 4) return;

        let element = document.createElement('div');
        element.id = participant.sid;
        element.innerText = participant.identity;
        element.className = 'open_video';

        participant.on('trackSubscribed', track => this.trackSubscribed(element, track));
        participant.on('trackUnsubscribed', track => this.trackUnsubscribed(track));
        participant.on('trackAdded', track => {
          // console.warn('trackAdded', track);
          if (track.kind === 'data') {
            track.on('message', message => {
              this.handle_message(message);
            });
          }
        });

        participant.tracks.forEach(publication => {
          if (publication.isSubscribed) {
            this.trackSubscribed(element, publication.track);
          }
        });

        this.$refs.participants.appendChild(element);
        this.participants.push({
          id: element.id,
          participant_id: element.innerText
        });
        this.create_elem(element);

        const participants = this.$refs.participants.childNodes;

        for (let i = 0; i < participants.length; i++) {
          if (participants[i].tagName === 'DIV') {
            participants[i].classList.remove('open_video');
          }
        }
        document.getElementById(element.id).classList.add('open_video');
      },

      create_elem(elem) {
        let micro = document.createElement('div');
        micro.className = 'micro';
        micro.id = elem.innerText;

        let name = document.createElement('div');
        name.className = 'participant-name';
        name.id = `name_${elem.innerText}`;

        // const find_elem = this.data.participants
        //   ? this.data.participants.find(
        //       el => el.id_participant === elem.innerText
        //     )
        //   : false;

        // if(find_elem) {
        //   let name = document.createElement("div");
        //   name.className = 'name';
        //   name.innerText = find_elem.name;

        //   document.getElementById(`${elem.id}`).appendChild(name);
        // }

        if (this.is_recruiter) {
          let hangup = document.createElement('div');
          hangup.className = 'hangup';
          hangup.id = elem.innerText;

          document.getElementById(`${elem.id}`).appendChild(hangup);
        }
        document.getElementById(`${elem.id}`).appendChild(micro);
        document.getElementById(`${elem.id}`).appendChild(name);

        this.partipiants_names_list.forEach(item => {
          let el = document.getElementById(`name_${item.id_participant}`);
          if (el) {
            el.innerText = item.name;
          }
        });
      },

      participantDisconnected(participant) {
        // console.warn('participantDisconnected', participant);
        if (
          document.getElementById(participant.sid) &&
          document.getElementById(participant.sid).remove
        ) {
          document.getElementById(participant.sid).remove();
        }

        let ind = this.participants.findIndex(el => el.id === participant.sid);
        this.participants.splice(ind, 1);
      },

      trackSubscribed(element, track) {
        // console.warn('trackSubscribed', track);
        if (track.kind === 'data') {
          track.on('message', message => {
            this.handle_message(message);
          });
        }
        element.appendChild(track.attach());
      },

      trackUnsubscribed(track) {
        // console.warn('trackUnsubscribed', track);
        if (!track || !track.detach) {
          return;
        }
        track.detach().forEach(element => {
          if (element && element.remove) {
            element.remove();
          }
        });
      },

      mute_video() {
        if (!this.videoMuted) {
          this.room.localParticipant.videoTracks.forEach(track => {
            track.unpublish();
          });
          this.videoMuted = true;
        } else {
          Video.createLocalVideoTrack(this.config.tracks.video).then(track => {
            this.room.localParticipant.publishTrack(track);
          });
          this.videoMuted = false;
        }
      },

      mute_audio() {
        if (!this.audioMuted) {
          this.audioMuted = true;
          this.room.localParticipant.audioTracks.forEach(track => {
            track.unpublish();
          });
        } else {
          this.audioMuted = false;
          Video.createLocalAudioTrack(this.config.tracks.audio).then(track => {
            this.room.localParticipant.publishTrack(track);
          });
        }
      },

      set_speaker(participant = null) {
        // console.warn('set_speaker', participant);

        if (participant) {
          this.current_speaker = document.getElementById(participant.sid);
          this.current_speaker.classList.add('active');
        } else {
          this.current_speaker.classList.remove('active');
        }

        this.sendMessage(
          JSON.stringify({
            type: 'setSpeakerFromMessage',
            participant
          })
        );
      },

      setSpeakerFromMessage(participant = null) {
        if (participant) {
          const participants = this.$refs.participants.childNodes;

          for (let i = 0; i < participants.length; i++) {
            if (participants[i].tagName === 'DIV') {
              participants[i].classList.remove('active');
            }
          }

          this.current_speaker = document.getElementById(participant.sid);
          this.current_speaker.classList.add('active');
        }
      },

      set_hangup(v) {
        this.hangup_room = v;
      },

      hangup() {
        this.room.localParticipant.tracks.forEach(track => {
          track.unpublish();
        });

        this.room.disconnect();
        this.set_hangup(false);

        if (this.isClosed) {
          this.$emit('end_room_too_many');
        } else {
          this.$emit('end_room');
        }
      },

      tooManyExitRoom() {
        if (this.room && this.room.localParticipant && this.room.localParticipant.tracks) {
          this.room.localParticipant.tracks.forEach(track => {
            track.unpublish();
          });
        }

        if (this.room) {
          this.room.disconnect();
        }
        this.set_hangup(false);
        // this.$emit('end_room_too_many');
      },

      hangup_all() {
        this.sendMessage('hangup_all');
        this.$emit('end_room');
      },

      hangup_only(elem) {
        let options = {
          token: this.data.token,
          hash: this.data.room.hash,
          id: elem.id
        };

        this.$store.dispatch('online_interview/delete', options).then(() => {
          document.getElementById(elem.parentElement.id).remove();
        });
      },

      open_video(elem) {
        const participants = this.$refs.participants.childNodes;

        for (let i = 0; i < participants.length; i++) {
          if (participants[i].tagName === 'DIV') {
            participants[i].classList.remove('open_video');
          }
        }
        document.getElementById(elem.parentElement.id).classList.add('open_video');
      },

      set_participant(e) {
        if (e.target.className === 'hangup') {
          this.hangup_only(e.target);
        } else if (e.target.parentElement.className !== 'room__videos') {
          this.open_video(e.target);
        }
      },

      record() {
        let options = {
          token: this.data.token,
          hash: this.data.room.hash
        };

        if (!this.record_video) {
          this.$store.dispatch('online_interview/start_record', options);
          this.record_video = true;
          this.sendMessage('record_video_start');
        } else {
          this.$store.dispatch('online_interview/stop_record', options);
          this.record_video = false;
          this.sendMessage('record_video_stop');
        }
      },

      sendMessage(message) {
        this.dataTrackPublished.promise.then(() => {
          this.localDataTrack.send(message);
        });
      },

      end_time() {
        this.hangup();
      }
    }
  };
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.room {
  height: 100%;
  width: 100% position absolute;
  left: 0;
  top: 0;

  &__recruiter {
    width: calc(100% - 500px);
    .room__videos {
      height: 100%;
      // video {
      //   max-width: 100%;
      // }
      .local-video {
        position: relative;
        &__preview {
          position: absolute;
          width: 240px;
          height: 154px;
        }

        .participant-name {
          position: absolute;
          top: auto;
          right: auto;
          left: 0;
          bottom: 10px;
          text-align: center;
          display: none;
          padding: 0 40px 0 20px;
          height: 22px;
          width: 100%;
          box-sizing: border-box;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          // font-family: Roboto;
          font-style: normal;
          font-weight: normal;
          font-size: 15px;
          line-height: 22px;
          letter-spacing: 0.005em;
          color: #ffffff;
          z-index: 999;
        }

        &:not(.local-video__preview) {
          .participant-name {
            display: none;
            bottom: auto;
            left: 50px;
            top: 40px;
            right: auto;
            text-align: left;
            padding: 0;
          }
        }

        &.local-video__preview:hover {
          background: red;
          ::v-deep .participant-name {
            position: absolute;
            top: auto;
            right: auto;
            left: 0;
            bottom: 10px;
            text-align: center;
            display: block;
            padding: 0 40px 0 20px;
            height: 22px;
            width: 100%;
            box-sizing: border-box;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            // font-family: Roboto;
            font-style: normal;
            font-weight: normal;
            font-size: 15px;
            line-height: 22px;
            letter-spacing: 0.005em;
            color: #ffffff;
            z-index: 999;
            display: block;
          }
        }
      }

      .participants {
        ::v-deep > div {
          width: 240px;
          height: 154px;
          top: 186px;
          &:nth-child(2) {
            top: 358px;
          }
          &:nth-child(3) {
            top: 528px;
          }
        }
      }
    }

    @media (max-width: 1280px) {
      width: calc(100% - 350px);
    }
  }

  .local-video {
    &.local-video-muted {
      &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: #000;
      }
    }
  }

  &__logo {
    width: 100%;
    padding: 7px 0;
    height: 134px;
    background: #fff;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      display: block;
      width: 134px;
      height: auto;
    }
  }

  &__videos {
    font-size: 0;
    height: calc(100% - 134px);
    position: relative;
    transition: all 0.5s;
    width: 100%;

    .local-video {
      height: 100%;
      width: 100%;

      .participant-name {
        position: absolute;
        top: auto;
        right: auto;
        left: 0;
        bottom: 10px;
        text-align: center;
        display: none;
        padding: 0 40px 0 20px;
        height: 22px;
        width: 100%;
        box-sizing: border-box;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        // font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 15px;
        line-height: 22px;
        letter-spacing: 0.005em;
        color: #ffffff;
        z-index: 999;
      }

      &:not(.local-video__preview) {
        .participant-name {
          display: none;
          bottom: auto;
          left: 50px;
          top: 40px;
          right: auto;
          text-align: left;
          padding: 0;
        }
      }

      &.local-video__preview:hover {
        background: red;
        ::v-deep .participant-name {
          position: absolute;
          top: auto;
          right: auto;
          left: 0;
          bottom: 10px;
          text-align: center;
          display: block;
          padding: 0 40px 0 20px;
          height: 22px;
          width: 100%;
          box-sizing: border-box;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          // font-family: Roboto;
          font-style: normal;
          font-weight: normal;
          font-size: 15px;
          line-height: 22px;
          letter-spacing: 0.005em;
          color: #ffffff;
          z-index: 999;
          display: block;
        }
      }

      ::v-deep video {
        height: 100%;
        width: 100%;
        object-fit: cover;
        transform: scale(-1, 1);
        transition: opacity 0.5s;
      }

      &__preview {
        position: absolute;
        top: 16px;
        right: 16px;
        width: 220px;
        height: 134px;
        transition: all 0.5s;
        z-index: 10;
        background-color: #000;
        box-sizing: border-box;

        video {
          height: 100%;
          width: 100%;
          object-fit: cover;
          transform: scale(-1, 1);
          transition: opacity 0.5s;
        }

        @media (max-width: 1280px) {
          width: 200px;
          height: 114px;
        }
      }
    }

    .participants {
      position: absolute;
      top: 0;
      right: 0;
      width: 100%;
      height: 100%;

      ::v-deep video {
        height: 100%;
        width: 100%;
        object-fit: cover;
        transition: opacity 0.5s;
      }

      ::v-deep > div {
        background-color: #000;
        width: 220px;
        height: 134px;
        z-index: 7;
        // margin-bottom: 18px;
        border: 2px solid transparent;
        position: absolute;
        box-sizing: border-box;
        right: 16px;
        top: 166px;

        &:nth-child(2) {
          top: 316px;
        }
        &:nth-child(3) {
          top: 468px;
        }

        &:hover .hangup,
        &:hover .participant-name {
          display: block;
        }

        &.active {
          border: 2px solid $green;

          .micro {
            display: none;
          }
        }

        &.open_video {
          width: 100%;
          height: 100%;
          border: none;
          background-color: #000;
          right: 0;
          top: 0 !important;
          transition: all 0.5s;
          pointer-events: none;
          z-index: 6;

          .hangup {
            display: none;
          }

          ::v-deep video {
            top: 1px;
            z-index: 12;
            width: 100%;
            height: 100%;
          }

          ::v-deep .micro {
            position: absolute;
            top: 10px;
            right: 10px;
            width: 20px;
            height: 24px;
            background: url('/static/images/elements/icon_mic.png') center no-repeat;
            display: block;
            bottom: auto;
            left: 50px;
            top: 40px;
            right: auto;
            padding: 0;
            text-align: left;
          }

          .micro {
            display: none;
          }

          video {
            height: 100%;
            width: 100%;
            object-fit: cover;
            transition: opacity 0.5s;
          }
        }

        ::v-deep video {
          top: 1px;
          z-index: 12;
          width: 100%;
          height: 100%;
        }

        ::v-deep .micro {
          position: absolute;
          top: 10px;
          right: 10px;
          width: 20px;
          height: 24px;
          background: url('/static/images/elements/icon_mic.png') center
            no-repeat;
          display: block;
        }

        ::v-deep .participant-name {
          position: absolute;
          left: 0;
          padding: 0 40px 0 20px;
          bottom: 10px;
          height: 22px;
          width: 100%;
          box-sizing: border-box;
          text-align: center;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          display: none;
          // font-family: Roboto;
          font-style: normal;
          font-weight: normal;
          font-size: 15px;
          line-height: 22px;
          letter-spacing: 0.005em;
          color: #ffffff;
        }

        ::v-deep .hangup {
          position: absolute;
          bottom: 10px;
          right: 8px;
          width: 28px;
          height: 28px;
          box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
          border-radius: 50%;
          background: #f65046 url('/static/images/elements/icon_hangup.png')
            center no-repeat;
          cursor: pointer;
          z-index: 13;
          display: none;
        }

        ::v-deep .name {
          position: absolute;
          bottom: 10px;
          left: 8px;
          width: 50px;
        }
      }

      @media (max-width: 1280px) {
        ::v-deep > div {
          width: 200px;
          height: 114px;
          top: 146px;
          &:nth-child(2) {
            top: 274px;
          }
          &:nth-child(3) {
            top: 400px;
          }
        }
      }
    }
  }

  &__controls {
    display: flex;
    align-items: center;
    bottom: 51px;
    left: 50%;
    transform: translateX(-50%);
    position: absolute;
    z-index: 13;
  }

  &__hangup {
    width: 500px;
    background: #ffffff;
    border-radius: 2px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 99;
    padding: 34px 20px 34px;

    &-title {
      font-weight: 500;
      font-size: 28px;
      line-height: 41px;
      text-align: center;
      letter-spacing: 0.005em;
      color: #233346;
      margin-bottom: 19px;
    }

    &-btns {
      display: flex;
      justify-content: center;

      .room__hangup-btn_left {
        margin-right: 6px;
        width: 118px;
      }

      .room__hangup-btn_right {
        padding: 10px 13px;
      }
    }

    &-close {
      width: 15px;
      height: 15px;
      position: absolute;
      right: 20px;
      top: 20px;
      cursor: pointer;

      &:before,
      &:after {
        position: absolute;
        top: 0;
        right: 50%;
        content: '';
        display: block;
        width: 2px;
        height: 18px;
        background: #7f8b99;
      }

      &:before {
        transform: rotate(45deg);
      }

      &:after {
        transform: rotate(-45deg);
      }
    }
  }
}
</style>

<style lang="scss">
  .room.room__candidate {
    .timer-block {
      top: 214px;
    }

    .room__videos .participants > div.open_video {
      background: transparent;

      video {
        width: auto;
        max-width: 100%;
        display: block;
        margin: 0 auto;
      }
    }
  }
</style>
